module.exports = __webpack_public_path__ + "static/media/BatchIcon.f8438b1b.svg";